import { render, staticRenderFns } from "./CommonLocation.vue?vue&type=template&id=6ecd444a&scoped=true"
import script from "./CommonLocation.vue?vue&type=script&lang=js"
export * from "./CommonLocation.vue?vue&type=script&lang=js"
import style0 from "./CommonLocation.vue?vue&type=style&index=0&id=6ecd444a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd444a",
  null
  
)

export default component.exports